import React from 'react';
import logo from '../../images/logo.png';
import './Header.css';

const Header = () => {


    return (
        <>
            <header id="header">
                <div className="header__wrapper">
                    <div className="brand__logo--wrapper">
                        <a href="/">
                            <img src={logo} alt="" />
                        </a>
                    </div>
                    <div className="menu__wrapper">
                        <input type="checkbox" id="menuBtn" />
                        <label htmlFor="menuBtn" id='menuBtn__label'>
                            <span className="nav__btn"></span>
                        </label>
                        <nav className="nav__menu">
                            <ul>
                                <li><a className="nav__link" href="/">Home</a></li>
                                <li><a className="nav__link" href="/#about">About</a></li>
                                <li><a className="nav__link" href="/#services">Services</a></li>
                                <li><a className="nav__link" href="/#portfolio">Portfolio</a></li>
                                <li><a className="nav__link" href="/#contact">Contact</a></li>
                            </ul>
                            <div className="my__info">
                                <span className="say__hello">Say Hello</span>
                                <ul>
                                    <li><a className="nav__link" href="mailto:rostamsardar446@gmail.com">Send Me Email</a></li>
                                    <li><a className="nav__link" href="tel:01321070987">Call Me</a></li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;